var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("\n    LOADING\n  ")]):_c('div',{attrs:{"id":"neededUserSwipes"}},[_c('div',{staticClass:"chart-wrapper"},[_c('apexchart',{attrs:{"type":"bar","height":"500","options":_vm.chartOptions,"series":_vm.series}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d51e7fde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Visualizations/NeededUserSwipes.vue
// module id = null
// module chunks = 